<a tabindex="0" class="close" (click)="onClose($event)">
  <span class="sr-only">close window</span><i aria-hidden="true">
    <svg><use href="#icon-close"></use></svg>
  </i>
</a>
  @if (!!moduleConfig?.ExpertsSupported){
<div class="component-heading">
  <div class="image">
    <fourd-expert-image [expert]="expert()"></fourd-expert-image>
  </div>
  <div>
    <h4>{{expert()?.Nickname}} - PIN {{expert()?.ExpertFourDigitId}}</h4>
    @if (showExpertStatus())
    {
    <div class="expert_status">
      @if (isExpertAvailable()) {
      <div class="available">
        <span>Available</span>
      </div>
      }
      @else if (isExpertBusy()) {
      <div class="busy">
        <span>Busy</span>
      </div>
      }
      @else {
      <div class="unavailable">
        <span>Away</span>
      </div>
      }
    </div>
    }
  </div>
  <div class="spacer"></div>
</div>
  } @else {
<div class="component-heading">
  <div class="image">
    <fourd-brand-logo></fourd-brand-logo>
  </div>
  <div>
    <h4>{{config()?.BrandHeadingText ?? config()?.BrandName}}</h4>
  </div>
  <div class="spacer"></div>
</div>
}
